import { Observable } from 'rxjs/internal/Observable';
import { ListerConfigurationHttpService } from './lister-configuration-http.service';
import { Injectable } from '@angular/core';
import { ListerColumnConfig, ProductListerConfigDto } from '@admin/containers/system-configuration-page/sections/lister-configuration/lister-configuration.types';

@Injectable({
  providedIn: 'root'
})

export class ListerConfigurationService {

    constructor(private readonly listerHttpService: ListerConfigurationHttpService){}

    saveListerConfiguration(listerConfiguration: ListerColumnConfig[], product: string): Observable<object>{
        const configToSave = listerConfiguration.map(x => this.mapSelectedListerConfigFlorSaving(x, product));
        
        return this.listerHttpService.saveListerConfiguration(configToSave);
    }

    mapSelectedListerConfigFlorSaving(listerConfiguration: ListerColumnConfig, product: string): ProductListerConfigDto {
      let saveRequest = new ProductListerConfigDto();

      saveRequest.Name = listerConfiguration.ListerName;
      saveRequest.Product = product;
      saveRequest.AllowedListerColumns = listerConfiguration.ColumnConfig.filter((config) => {
        return config.Allowed;
      }).map((item) => {
        return item.ColDef.Field
      });

      saveRequest.DefaultListerColumns = listerConfiguration.ColumnConfig.filter((config) => {
        return config.Default;
      }).map((item) => {
        return item.ColDef.Field
      });

      return saveRequest;
      
    }
}